const routes = {
  LANDING: '/',
  ACCOUNT_LOGIN_START: '/register/awaiting-confirmation',
  ACCOUNT_LOGIN_DONE: '/auth/link',
  LOGGED_IN_HOME: '/app',
  ONBOARD: '/onboard',
}

export { routes }
